<div class="saved-vacancies">
  <div class="saved-vacancies__hero">
    <div class="vacancy-hero">
      <h1 class="vacancy-hero__title">{{ 'vacancies.saved.hero_title' | translate }}</h1>
    </div>
  </div>

  <div class="vacancy-container saved-vacancies__content">
    <!-- Loading -->
    <div class="saved-vacancies__loading" *ngIf="loading">
      <p>{{ 'shared.loading' | translate }}...</p>
    </div>

    <ng-container *ngIf="savedVacancies$ | async as savedVacancies">
      <!-- Empty state -->
      <div class="vacancy-empty-state" *ngIf="!loading && savedVacancies.length === 0">
        <div class="saved-vacancies__empty-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
          </svg>
        </div>
        <h2 class="vacancy-empty-state__title">{{ 'vacancies.saved.empty_title' | translate }}</h2>
        <p class="vacancy-empty-state__text">{{ 'vacancies.saved.empty_text' | translate }}</p>
        <a routerLink="/profile-check/vacancies" class="saved-vacancies__back-link">
          {{ 'vacancies.saved.back_link' | translate }}
        </a>
      </div>

      <!-- Saved list -->
      <div class="vacancy-grid" *ngIf="savedVacancies.length > 0">
        <bwc-vacancy-card
          *ngFor="let vacancy of savedVacancies"
          [vacancy]="vacancy"
          [isLiked]="true"
          [hideMatchBar]="true"
          (liked)="unlike($event)"
          (cardClick)="openDetail($event)"
        ></bwc-vacancy-card>
      </div>
    </ng-container>
  </div>

  <bwc-vacancy-detail
    *ngIf="detailData"
    [data]="detailData"
    [hideMatchBar]="true"
    (closed)="closeDetail()"
  ></bwc-vacancy-detail>
</div>
